import React from 'react';
import ReactDOM from 'react-dom/client';  // Use 'react-dom/client' for React 18
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));  // Create the root
root.render(<App />);

<head>
  <meta name="google-site-verification" content="your-verification-code" />
  <meta name="viewport" content="width=device-width, initial-scale=1"/>

  ...
</head>

